import { api } from './client'

export const safetyApi = {
  // Clears the caller's own safety gate. Immediate and unconditional —
  // see app/api/safety.py. The user_id in the body must match the
  // authenticated user; the server enforces it.
  confirm: (userId, token) => api.post('/safety/confirm', { user_id: userId }, token),
}
